import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { QualyzApi } from '../services/qualyz'
import { fehlerText } from '../lib/api'

/**
 * Zurücksetz-Link anfordern.
 *
 * Die Antwort ist IMMER dieselbe, auch wenn es die Adresse nicht gibt --
 * sonst wird das Formular zum Adressverzeichnis. Deshalb steht hier kein
 * „Konto nicht gefunden", sondern eine Bestätigung im Konjunktiv.
 */
export default function PasswortVergessenPage() {
  const [email, setEmail] = useState('')
  const [laeuft, setLaeuft] = useState(false)
  const [fertig, setFertig] = useState<string | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)

  const absenden = async (e: FormEvent) => {
    e.preventDefault()
    setFehler(null)
    setLaeuft(true)
    try {
      const antwort = await QualyzApi.passwortVergessen(email.trim())
      setFertig(antwort.hinweis)
    } catch (f) {
      setFehler(fehlerText(f))
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <div className="q-page q-page--schmal">
      <section className="q-card">
        <div className="q-card-head">
          <h3 className="q-card-title">Passwort vergessen</h3>
        </div>
        {fertig ? (
          <>
            <p className="q-job-result is-ok q-karte-rand">{fertig}</p>
            <p className="q-karte-text">
              Der Link in der E-Mail gilt eine Stunde und nur einmal. Schau auch im
              Spam-Ordner nach.
            </p>
          </>
        ) : (
          <form onSubmit={absenden} className="q-formular">
            <p className="q-karte-text">
              Gib deine E-Mail-Adresse ein. Wenn es dazu ein Konto gibt, schicken wir
              einen Link zum Zurücksetzen.
            </p>
            <label className="q-feld">
              <span>E-Mail-Adresse</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoFocus
              />
            </label>
            {fehler && <p className="qa-hinweise q-karte-rand">{fehler}</p>}
            <div className="q-job-foot">
              <Link to="/login" className="q-job-meta">Zurück zur Anmeldung</Link>
              <button type="submit" className="q-btn q-btn-primary" disabled={laeuft || !email}>
                {laeuft ? 'Wird gesendet …' : 'Link anfordern'}
              </button>
            </div>
          </form>
        )}
      </section>
    </div>
  )
}
